module.exports = __webpack_public_path__ + "static/media/sent.8a73a675.png";